import { BottomTableHeaderProps } from '../types';

export const BottomTableHeader = ({ children }: BottomTableHeaderProps) => {
  return (
    <div style={{ display: 'flex', padding: '1rem', gap: '1rem' }}>
      {children}
    </div>
  );
};
